/* prettier-ignore */

import { Component, HostListener, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ToolsService } from 'src/app/services/tools.service';
import { combineLatest, filter, Subscription, take } from 'rxjs';
import { NewCustomRouteService } from '../new-custom-route.service';
import { RestService } from 'src/app/services/rest.service';
import { IonicModule } from '@ionic/angular';
import { SendUpdateRouteService } from '../../send-update-route/send-update-route.service';
import { DebugService } from 'src/app/services/debug.service';
@Component({
    selector: 'cicerone-load-from-api',
    imports: [
        CommonModule, 
        IonicModule
    ],
    standalone: true,
    templateUrl: './load-from-api.component.html',
    styleUrls: ['./load-from-api.component.scss'],
})

export class LoadFromAPIComponent {
    private debugService = inject(DebugService);
    private subscription: Subscription;

    private tools = inject(ToolsService);
    private route = inject(ActivatedRoute);
    private router = inject(Router)
    private rest = inject(RestService)
    private routeService = inject(NewCustomRouteService)
    private sendUpdateService = inject(SendUpdateRouteService);
    public routeId: any;
    public showSpinner = true;
    private currentCustomRouteUrl: any;

    constructor() {
        this.routeService.initializeData();
    }
   
    ngOnInit(){
        this.routeId = this.route.snapshot.paramMap.get('id');
        this.currentCustomRouteUrl = location.href; //`${location.href}/${this.routeId}`;
        this.initializeData();
        const url = this.router.url;
        if (url.includes('tech-edit')){
            //Deshabiltar boton derecho raton
            document.addEventListener('contextmenu', (event) => event.preventDefault());
            this.tools.isTechEditMode.set(true);
        }
    }

    private initializeData() {
        combineLatest([this.routeService.registerOptions$, this.routeService.routeItems$]).pipe(
            filter(([registerOptions, routeItems]) => registerOptions !== null && routeItems !== null), 
            take(1)
        ).subscribe(() => {
            if (this.tools.isApp)  this.loadAppFromApi();
            if (this.tools.isDistributor) this.loadDistributorFromApi();
        });
    }

    loadAppFromApi(){
        this.subscription = this.rest.getRoute(this.routeId).subscribe((response) => {
            this.debugService.debug(response, '[LoadFromApiComponent] Route APP API Response');

            if (this.errorFromApi(response)){
                this.debugService.error('Error getting APP Route', '[LoadFromApiComponent]');
                if (this.tools.isTechEditMode()){
                    this.showSpinner = false;
                    return;
                }
                this.router.navigateByUrl('/home')
                return;
            }

            this.setRouteLang(response?.lang)
            this.setRouteInfo(response?.cicerone);
            const route = response.cicerone?.route ? JSON.parse(response.cicerone.route) : [];
            const mappedRoute = this.routeService.mapRouteStructure(route);
            const userData = this.generateUserData(response?.cicerone)
            this.sendUpdateService.userData.set(userData);
            this.routeService.route.set(mappedRoute);
            this.routeService.checkRightTimes();
            this.routeService.filterAppItems();
            this.router.navigateByUrl('/custom-route');
        });
    }

    loadDistributorFromApi(){
        this.rest.getRouteDistributor(this.routeId).subscribe((response) => {
            this.debugService.debug(response, '[LoadFromApiComponent] Route DISTRIBUTOR API Response');
            if (this.errorFromApi(response)){
                this.debugService.error('Error getting DISTRIBUTOR route', '[LoadFromApiComponent]');
                if (this.tools.isTechEditMode()){
                    return;
                }
                this.router.navigateByUrl('/home')
                return;
            }
            this.setRouteLang(response?.lang)
            this.setRouteInfo(response?.cicerone);
            const route = response.cicerone?.route ? JSON.parse(response.cicerone.route) : [];
            const mappedRoute = this.routeService.mapRouteStructure(route);
            const userData = this.generateUserData(response?.cicerone)
            this.sendUpdateService.userData.set(userData);
            this.routeService.route.set(mappedRoute);
            this.routeService.checkRightTimes();
            this.routeService.filterDistributorItems();
            this.router.navigateByUrl('/custom-route');
        });
    }

    errorFromApi(response){
        if (!response.error) return false;
        return true
    }

    private generateUserData(route){
        return {
            name: route?.name,
            id: route?.id,
            pdfs: this.jsonToText(route?.user_pdfs),
            info: this.jsonToText(route?.user_info)
        }
    }

    private jsonToText(value){
        if (!value) return null;
        try{ return JSON.parse(value) }
        catch(e){ return value }
    }

    setRouteInfo(response){
        this.sendUpdateService.item.update(prev => ({...prev, id: response.id, route_days: response.route_days}))
        if (response.image && response.image !== '')
          this.sendUpdateService.item.update(prev => ({...prev, image: response.image}))
  
        if (response.name && response.name !== '' && Object.values(response.name)?.some(value => value && value !== ''))
          this.sendUpdateService.item.update(prev => ({...prev, name: response.name}))
    }

    setRouteLang(lang){
        if (!lang) 
            return;

        this.tools.changeLanguage(lang.toLowerCase());
    }

    ngOnDestroy(){
        this.showSpinner = true;
    }

}